import createIcon from '../../createIcon';

/**
 * @component @name Lightbulb
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAyMUM5IDIxLjUgOS40IDIyIDEwIDIySDE0QzE0LjYgMjIgMTUgMjEuNSAxNSAyMVYyMEg5VjIxWk0xMiAyQzguMSAyIDUgNS4xIDUgOUM1IDExLjQgNi4yIDEzLjUgOCAxNC43VjE3QzggMTcuNSA4LjQgMTggOSAxOEgxNUMxNS42IDE4IDE2IDE3LjUgMTYgMTdWMTQuN0MxNy44IDEzLjQgMTkgMTEuMyAxOSA5QzE5IDUuMSAxNS45IDIgMTIgMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Lightbulb = createIcon('Lightbulb', [
  [
    'path',
    {
      d: 'M9 21C9 21.5 9.4 22 10 22H14C14.6 22 15 21.5 15 21V20H9V21ZM12 2C8.1 2 5 5.1 5 9C5 11.4 6.2 13.5 8 14.7V17C8 17.5 8.4 18 9 18H15C15.6 18 16 17.5 16 17V14.7C17.8 13.4 19 11.3 19 9C19 5.1 15.9 2 12 2Z',
      key: 'wndtd',
    },
  ],
]);

export default Lightbulb;
